import { createGetDataReducer } from "./CommonReducer";
import {
  SUBSCRIPTION_PLAN_LIST,
  SUBSCRIPTION_PLAN_DETAILS,
  SUBSCRIPTION_PLAN_UPDATE,
} from "../../Constants/SubscriptionPlanConstants";

export const SubscriptionPlanListReducer = createGetDataReducer(SUBSCRIPTION_PLAN_LIST);
export const SubscriptionPlanDetailsReducer = createGetDataReducer(SUBSCRIPTION_PLAN_DETAILS);
export const SubscriptionPlanUpdateReducer = createGetDataReducer(SUBSCRIPTION_PLAN_UPDATE);
